import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import { Form, Input, Radio, Checkbox, DatePicker, Upload, Dialog, Button, Notification, Message } from 'element-react';
import { actionCreators } from './store';
import { getCookie } from '../../utils/cookie';
import http from '../../utils/request';
import { pictureConfig } from '../../utils/defaultSetting';

const { picFormat, picSize } = pictureConfig;
class PublishCta extends Component {

  constructor(props) {
    super(props);

    this.state = {
      form: {
        name: '',        // 技术成果名称 name
        domain: '',      // 技术成果领域 domain
        patent: '',      // 专利情况 patent
        operation: [],   // 合作需求 operation
        end: null,       // 截止日期
        number: '',      // 成果编号
        maturity: '',    // 成熟度
        address: '',     // 技术地点
        file: [],        // 文件上传
        price: '',       // 预计投入金额
        span: '',        // 关键词
        account: '',     // 技术成果简介
        des: '',         // 技术成果描述,
        innovation: '',  // 优势和创新
        application: '', // 场景应用
        profit: '',      // 预期收益
        team: '',        // 研发团队
      },
      rules: {
        name: [
          { required: true, message: '请填写技术/成果名称', trigger: 'blur' }
        ],
        patent: [
          { required: true, message: '请选择专利情况', trigger: 'change' }
        ],
        domain: [
          { required: true, message: '请选择技术/成果领域', trigger: 'change' }
        ],
        operation: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        ],
        maturity: [
          { required: true, message: '请选择技术/成果成熟度', trigger: 'change' }
        ],
        account: [
          { required: true, message: '请输入技术/成果简介', trigger: 'blur' }
        ],
        des: [
          { required: true, message: '请输入技术/成果描述', trigger: 'blur' }
        ]
      },
      disabled: false,
      dialogImageUrl: '',
      dialogVisible: false,
    }
    this.uploadRef = React.createRef()
  }

  componentDidMount() {
    this.props.fecthInitData();
  }

  handleChange(key, value) {
    this.setState({
      form: Object.assign({}, this.state.form, { [key]: value }),
      disabled: false
    });
  }

  onChange(value) {
    this.setState({ domain: value, disabled: false });
  }

  // Handle uplaod image
  handlePictureCardPreview(file) {
    this.setState({
      dialogImageUrl: file.url,
      dialogVisible: true,
    })
  }

  handleSuccess(data) {
    const { form } = this.state;
    const { file } = form;
    file.push(data.data[0])
    // let newTestData = Object.assign(this.state.form, { ['file']: data.data });
    this.setState({
      form: {
        ...form,
        file
      },
    });
  }

  handleRemove = (file) =>{
    const that = this;
    const { response } = file
    const delFile = response ? response.data : ''
    if(delFile){
      const { form } = this.state;
      const { file } = form;
      const index = file.indexOf(delFile[0])
      if(index>-1){
        file.splice(index,1)
        that.setState({
          form: {
            ...form,
            file
          }
        })
      }
    }
  }

  handleBefore = (file) =>{
    if (file && file.name) {
      const point = file.name.lastIndexOf('.');
      const type = file.name.substr(point);
      const isPic = picFormat.includes(type);
      if (!isPic) {
        Message({
          type: 'error',
          message: '上传图片格式为jpg,jpeg,png!',
          duration: 3000,
          customClass: 'zZindex'
        })
        this.uploadRef.current.state.fileList.pop();
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < picSize;
      if (!isLt2M) {
        Message({
          type: 'error',
          message: `上传图片最大为${picSize}M!`,
          duration: 3000,
          customClass: 'zZindex'
        })
        this.uploadRef.current.state.fileList.pop();
        return false;
      }
    }
    return true;
  }

  // Submit
  handleSubmit(e) {
    e.preventDefault();
    const self = this;

    this.setState({ disabled: true });

    const { name, domain, patent, operation, end, address, file, price, span, account, des, innovation, application, profit, team, number } = this.state.form;

    const cookie = getCookie('userinfo') ? JSON.parse(getCookie('userinfo')) : '';
    const token = cookie ? cookie.token : '';

    this.refs.form.validate((valid) => {
      if (valid) {

        const parmas = {
          token: token,
          name,
          domain,
          patent,
          operation: operation.toString(),
          end: end ? end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate() : null,
          address,
          file: file.join(','),
          price,
          span,
          account,
          des,
          innovation,
          application,
          profit,
          team,
          number
        }

        http('post', '/achieve/detail/publish', parmas).then((res) => {

          if (res.code === 200) {
            self.open(res.msg);
            setTimeout(() => {
              self.props.history.goBack();
            },2000);
          } else {
            self.open2(res.msg);
            setTimeout(() => {
              self.setState({ disabled: false });
            },2000)
          }

        });
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  // submit success info-box
  open(msg) {
    Notification({
      title: '成功',
      message: msg,
      type: 'success',
      duration: 2000
    });
  }

  // submit error info-box
  open2(msg) {
    Notification.error({
      title: '错误',
      message: msg,
      duration: 2000
    });
  }

  render() {

    const { dialogImageUrl, dialogVisible, disabled } = this.state;
    const { domain, patent, operation, maturity } = this.props;

    return (
      <div className="publish">

        <Form ref="form" labelPosition="top" model={this.state.form} rules={this.state.rules} className="publish__wrap">

          <Form.Item className="publish__item" label="技术/成果名称" prop="name">
            <Input value={this.state.form.name} onChange={this.handleChange.bind(this, 'name')}></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="技术/成果领域" prop="domain">
            <Radio.Group value={this.state.form.domain} onChange={this.handleChange.bind(this, 'domain')} className="publish__item--inner">
              {
                domain.map((item) => {
                  return (
                    <Radio value={item.get('val')} key={item.get('val')}>{item.get('name')}</Radio>
                  )
                })
              }
            </Radio.Group>
          </Form.Item>

          <Form.Item className="publish__item" label="专利情况" prop="patent">
            <Radio.Group value={this.state.form.patent} onChange={this.handleChange.bind(this, 'patent')} className="publish__item--inner">
              {
                patent.map((item) => {
                  return (
                    <Radio value={item.get('val')} key={item.get('val')}>{item.get('name')}</Radio>
                  )
                })
              }
            </Radio.Group>
          </Form.Item>

          <Form.Item className="publish__item" label="合作需求" prop="operation">
            <div className="publish__item--inner">
              <Checkbox.Group value={this.state.form.operation} onChange={this.onChange.bind(this, 'operation')}>
                {
                  operation.map((item) => {
                    return (
                      <Checkbox label={item.get('val')} key={item.get('val')} name="operation">{item.get('name')}</Checkbox>
                    )
                  })
                }
              </Checkbox.Group>
            </div>
          </Form.Item>

          <Form.Item className="publish__item" label="截止日期" >
            <div className="publish__item--inner block">
              <DatePicker
                value={this.state.form.end}
                placeholder="选择日期"
                onChange={this.handleChange.bind(this, 'end')}
                disabledDate={time => time.getTime() < Date.now() - 8.64e7}
              />
            </div>
          </Form.Item>

          <Form.Item className="publish__item" label="专利号/登记号/品种权号/成果编号">
            <Input value={this.state.form.number} onChange={this.handleChange.bind(this, 'number')}></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="技术/成果成熟度" prop="maturity">
            <Radio.Group value={this.state.form.maturity} onChange={this.handleChange.bind(this, 'maturity')} className="publish__item--inner">
              {
                maturity.map((item) => {
                  return (
                    <Radio value={item.get('val')} key={item.get('val')}>{item.get('name')}</Radio>
                  )
                })
              }
            </Radio.Group>
          </Form.Item>

          <Form.Item className="publish__item" label="技术/成果地点">
            <Input value={this.state.form.address} onChange={this.handleChange.bind(this, 'address')}></Input>
          </Form.Item>

          <div className="publish__item">
            <h2 className="title">成果图片</h2>
            <div className="publish__item--inner">
              <Upload
                ref={this.uploadRef}
                action="http://api.gmih.scimea.cn/achieve/detail/files"
                listType="picture-card"
                // multiple={true}
                name="file[]"
                beforeUpload={(file) => this.handleBefore(file)}
                onPreview={file => this.handlePictureCardPreview(file)}
                onSuccess={file => this.handleSuccess(file)}
                onRemove={(file) => this.handleRemove(file)}
              >
                <i className="el-icon-plus"></i>
              </Upload>
              <Dialog
                visible={dialogVisible}
                size="tiny"
                onCancel={() => this.setState({ dialogVisible: false })}
              >
                <img width="100%" src={dialogImageUrl} alt="" />
              </Dialog>
            </div>
          </div>

          <Form.Item className="publish__item" label="资金需求">
            <Input value={this.state.form.price} onChange={this.handleChange.bind(this, 'price')}></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="关键词 ( 多个关键词以英文分号“;”隔开 )">
            <Input value={this.state.form.span} onChange={this.handleChange.bind(this, 'span')}></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="技术/成果简介" prop="account">
            <Input
              value={this.state.form.account}
              onChange={this.handleChange.bind(this, 'account')}
              type="textarea"
              autosize={{ minRows: 4, maxRows: 6 }}
            ></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="技术/成果描述" prop="des">
            <Input
              value={this.state.form.des}
              onChange={this.handleChange.bind(this, 'des')}
              type="textarea"
              autosize={{ minRows: 4, maxRows: 6 }}
            ></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="优势和创新" >
            <Input
              value={this.state.form.innovation}
              onChange={this.handleChange.bind(this, 'innovation')}
              type="textarea"
              autosize={{ minRows: 4, maxRows: 6 }}
            ></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="场景应用" >
            <Input
              value={this.state.form.application}
              onChange={this.handleChange.bind(this, 'application')}
              type="textarea"
              autosize={{ minRows: 4, maxRows: 6 }}
            ></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="预期收益">
            <Input value={this.state.form.profit} onChange={this.handleChange.bind(this, 'profit')}></Input>
          </Form.Item>

          <Form.Item className="publish__item" label="研发团队" >
            <Input
              value={this.state.form.team}
              onChange={this.handleChange.bind(this, 'team')}
              type="textarea"
              autosize={{ minRows: 4, maxRows: 6 }}
            ></Input>
          </Form.Item>

          <Form.Item>
            <Button className="" type="primary" disabled={ disabled }  onClick={this.handleSubmit.bind(this)}>提交</Button>
          </Form.Item>

        </Form>

      </div >
    )
  }
}

const mapState = (state) => ({
  domain: state.getIn(['publish', 'domain']),
  patent: state.getIn(['publish', 'patent']),
  operation: state.getIn(['publish', 'operation']),
  maturity: state.getIn(['publish', 'maturity']),
  submitState: state.getIn(['publish', 'submitState']),
  msg: state.getIn(['publish', 'msg'])
});

const mapDispatch = (dispatch) => ({

  fecthInitData() {
    dispatch(actionCreators.fetchPublishData());
  },

  submitFormData(obj) {
    dispatch(actionCreators.submitFormData(obj));
  }

});


export default connect(mapState, mapDispatch)(PublishCta);
